<template>
  <table>
    <tbody>
    <tr v-for="(provider, idx) in notApprovedProviderData" :key="`first-${idx}`">
    <th class="title disapproved" v-if="idx===0" :rowspan="notApprovedProviderData.length">未承認</th>
    <td class="price">{{ provider.name }}</td>
    <td class="price">{{ provider.email }}</td>
    <td class="price">{{ provider.tel }}</td>
     <td class="price">{{ provider.ｍissedUrl }}</td>
    <td class="price">{{ provider.group_name }}</td>
    <td class="price">{{ provider.title }}</td>
    <td class="delivery-frame">{{ provider.fetchDeliveryFrame }}</td>
    <td class="price">{{ provider.fetchDeliveryTime }}</td>
    <td class="price">{{ provider.fetchTargetAge }}</td>
    <td class="price">{{ provider.detail }}</td>
    <td class="price">{{ provider.fetchTool }}</td>
    <td class="price"><a :href="provider.url" target="_blank">{{ provider.url }}</a></td>
    <td class="price">{{ provider.eventName }}</td>
    <td class="price"><a :href="provider.exhibitor_url1" target="_blank">{{ provider.exhibitor_url1 }}</a></td>
    <td class="price"><a :href="provider.exhibitor_url2" target="_blank">{{ provider.exhibitor_url2 }}</a></td>
    <td class="price"><a :href="provider.exhibitor_url3" target="_blank">{{ provider.exhibitor_url3 }}</a></td>
    <td v-if="!provider.isRejected" class="btn-area">
      <button @click="openEditModal(provider)">編集</button>
      <button @click="$emit('accept', provider.docId)">承認</button>
      <button @click="openRejectModal(provider)">却下</button>
      <button @click="$emit('delete-user', provider.docId)">削除</button>
    </td>
  </tr>
  <tr  v-for="(provider, idx) in approvedProviderData" :key="`second-${idx}`">
    <th class="title approved" v-if="idx===0" :rowspan="approvedProviderData.length">承認済</th>
    <td class="price">{{ provider.name }}</td>
    <td class="price">{{ provider.email }}</td>
    <td class="price">{{ provider.tel }}</td>
     <td class="price">{{ provider.ｍissedUrl }}</td>
    <td class="price">{{ provider.group_name }}</td>
    <td class="price">{{ provider.title }}</td>
    <td class="delivery-frame">{{ provider.fetchDeliveryFrame }}</td>
    <td class="price">{{ provider.fetchDeliveryTime }}</td>
    <td class="price">{{ provider.fetchTargetAge }}</td>
    <td class="price">{{ provider.detail }}</td>
    <td class="price">{{ provider.fetchTool }}</td>
    <td class="price"><a :href="provider.url" target="_blank">{{ provider.url }}</a></td>
    <td class="price">{{ provider.eventName }}</td>
    <td class="price"><a :href="provider.exhibitor_url1" target="_blank">{{ provider.exhibitor_url1 }}</a></td>
    <td class="price"><a :href="provider.exhibitor_url2" target="_blank">{{ provider.exhibitor_url2 }}</a></td>
    <td class="price"><a :href="provider.exhibitor_url3" target="_blank">{{ provider.exhibitor_url3 }}</a></td>
    <td class="btn-area">
      <button @click="openEditModal(provider)" >編集</button>
      <button @click="openRejectModal(provider)">却下</button>
      <button @click="$emit('delete-user', provider.docId)">削除</button>
    </td>
  </tr>
  </tbody>
    <thead>
      <tr>
        <th scope="col">ママ</th>
        <th scope="col">申込者名</th>
        <th scope="col">申込者アドレス</th>
        <th class="email" scope="col">申込者電話番号</th>
        <th scope="col">見逃し配信用URL</th>
        <th scope="col">団体名</th>
        <th scope="col">配信タイトル</th>
        <th scope="delivery-frame">配信開始時間</th>
        <th scope="col">配信時間</th>
        <th scope="col">対象年齢</th>
        <th class="detail" scope="col">配信内容</th>
        <th scope="col">配信ツール選択</th>
        <th class="col" scope="col">視聴者用URL</th>
        <th class="col" scope="col">出展名</th>
        <th class="col" scope="col">出展者URL1</th>
        <th class="col" scope="col">出展者URL2</th>
        <th class="col" scope="col">出展者URL3</th>
        <th scope="col"></th>
      </tr>
    </thead>
    </table>
</template>

<script>
export default {
  props: {
    notApprovedProviderData: {
      type: Array,
      required: true
    },
    approvedProviderData: {
      type: Array,
      required: true
    }
  },
  methods: {
    openRejectModal (provider) {
      this.$emit('open-reject-modal', provider)
    },
    openEditModal (provider) {
      this.$emit('open-edit-modal', provider)
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  padding: 0;
  width: 850px;
  table-layout: fixed;
}

table tr {
  background-color: #fff;
  padding: .35em;
  border: 2px solid #eee;
}

table th{
  padding: 0.5em;
  border-right: 2px solid #fff;
  width: 100px;
}
table td {
  padding: .5em .5em;
  border-right: 2px solid #eee;
  text-align: center;
}
table th {
  font-size: .85em;
}
table thead tr{
  background-color: #50535d;
  color:#fff;
}
table tbody th {
    border-right: 2px solid #eee;
}
th.non {
    border-right: none;
}
.txt{
  text-align: left;
  font-size: .85em;
}
.price{
  color: #000;
  font-weight: bold;
  font-size:1.0em
}
.price span {
  font-size: .6em;
}
.red_bk{
  background:#e81010
}
.red-txt{
  color:#e81010
}
.btn{
  background:#e81010;
  border: 2px solid #e81010;
  color:#fff;
  padding: 1em;
  border-radius:20px;
  display:block;
  text-decoration:none;
  font-size:.8em
}
.btn:hover{
  background: #fff;
  border: 2px solid #e81010;
  color: #e81010;
  transition: .2s;
}
table .btnarea td {
  padding: .2em .5em;
  border-right: none
}

.title {
  font-size: 20px;
}
.btn-area button {
  margin-bottom: 3px;
}
.modal-title {
  text-align: center;
  font-size: 1.3em;
  margin-top: 30px;
}
.modal-form {
  text-align: center;
  margin-top: 20px
}
.modal-form button {
  margin: 20px;
}
.delivery-frame {
  white-space: break-spaces;
  color: black;
}
.route-area {
  margin: 20px 20px 20px 0;
  font-size: 1.5em;
}
.route-area .route{
  margin-left: 50px;
}
.title.approved {
  background-color:green;
}
.title.disapproved {
  background-color: red;
}
.detail {
  width: 300px;
}
.loading-container {
  position: absolute;
  top: 30%;
  left: 40%;
}
.rejected {
  background-color: #50535d
}
</style>
